import 'ui-core/utility/js/utils';

UX.utils.convertToArray = nodeList => Array.prototype.slice.call(nodeList);

UX.utils.isMacChromeOrSafari = () => {
    let userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('safari') !== -1) {
        return userAgent.indexOf('macintosh') > -1;
    }
};

UX.utils.isElementEmptyOrSpaces = el => el.value === null || el.value.match(/^ *$/) !== null;

UX.utils.readFromFile = async path => {
    const file = path,
        response = await fetch(file),
        data = await response.text();

    return data;
};

UX.utils.mutationObserver = (selector, configObj, callback, params, appendChild) => {
    const element = document.querySelector(selector);

    const observer = new MutationObserver(entries => {
        if (document.contains(element)) {
            callback(element, params);
            observer.disconnect();
        } else if (appendChild) {
            for (const entry of entries) {
                if (entry.type === 'childList' && entry.addedNodes.length > 0) {
                    const appendedElement = document.querySelector(selector);
                    if (appendedElement) {
                        observer.disconnect();
                        callback(element, params);
                    }
                }
            }
        }
    });

    observer.observe(document, configObj);
};

UX.utils.intersectionObserver = (selectors, configObj, callback, params) => {
    const elements = document.querySelectorAll(selectors);

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            const intersecting = entry.isIntersecting;
            if (intersecting) {
                callback(entry.target, params);
            }
        });
    }, configObj);

    elements.forEach(element => {
        observer.observe(element);
    });
};

UX.utils.isInViewport = element => {
    const rect = element.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

UX.utils.getCookie = cookieName => {
    const name = cookieName + '=',
        cookieDecoded = decodeURIComponent(document.cookie),
        cookieValues = cookieDecoded.split('; ');

    let result;

    cookieValues.forEach(value => {
        if (value.indexOf(name) === 0) result = value.substring(name.length);
    });

    return result;
};

UX.utils.setCookie = (cookieName, cookieValue, cookieAttributes) => {
    let {path = '/', expireDays = '', secure = '', domain = ''} = cookieAttributes || {};

    if (expireDays) {
        let date = new Date();
        date.setTime(date.getTime() + expireDays * 24 * 60 * 60 * 1000);
        expireDays = '; expires=' + date.toUTCString();
    }

    if (path) {
        path = `; path=${path}`;
    }

    if (secure) {
        secure = '; secure';
    }

    if (domain) {
        domain = `; domain=${domain}`;
    }

    document.cookie = `${cookieName}=${cookieValue}${expireDays}${path}${domain}${secure};`;
};

UX.utils.deleteCookie = (cookieName, path) => {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path};`;
};

// todo: check the need of these utilities during Embo migration

// UX.utils.changeImageWidthOnLoad = (image, minRatio) => {
//     window.addEventListener('load', () => {
//         resizeImages(image, minRatio);

//         const tocAbstractPreviews = Array.from(document.querySelectorAll(image));

//         if (tocAbstractPreviews.length) {
//             tocAbstractPreviews.forEach(item => {
//                 const image = item.querySelector('img');
//                 image?.addEventListener('load', () => {
//                     resizeImages(item, minRatio);
//                 });
//             });
//         }
//     });
// };

// UX.utils.menuRoleButton = () => {
//     const menuitems = document.querySelectorAll('nav [role="button"]');
//     function handelMenuItem(event, menuitem) {
//         if (event.keyCode === keyCodes.SPACE || event.keyCode === keyCodes.DOWN || event.keyCode === keyCodes.RETURN) {
//             const btnMenueItems = document.querySelectorAll('[aria-labelledby=' + "'" + event.target.id + "'" + '] a');
//             if (!event.target.parentNode.classList.contains('js--open')) {
//                 menuitem.click();
//             }
//             btnMenueItems[0].focus();
//             event.preventDefault();
//         }
//     }

//     function handelSubMenu(event, item) {
//         item.closest('div').scrollTo(0, 0);
//         const parentNode = event.target.parentNode.parentNode;
//         const btnMenueItems = parentNode?.querySelectorAll('a');
//         const index = Array.from(btnMenueItems)?.indexOf(event.target);
//         if (event.keyCode === keyCodes.DOWN || event.keyCode === keyCodes.UP) {
//             if (event.keyCode === keyCodes.DOWN && btnMenueItems[index + 1]) {
//                 btnMenueItems[index + 1].focus();
//             } else if (event.keyCode === keyCodes.DOWN && !btnMenueItems[index + 1]) {
//                 btnMenueItems[0].focus();
//             } else if (event.keyCode === keyCodes.UP && btnMenueItems[index - 1]) {
//                 btnMenueItems[index - 1].focus();
//             } else if (event.keyCode === keyCodes.UP && !btnMenueItems[index - 1]) {
//                 btnMenueItems[btnMenueItems.length - 1].focus();
//             }
//             event.preventDefault();
//         }
//     }

//     menuitems?.forEach(menuitem => {
//         menuitem.addEventListener('keydown', function () {
//             handelMenuItem(event, menuitem);
//         });

//         const submenuItems = document.querySelectorAll(`[aria-labelledby = "${menuitem.id}"] a`);
//         submenuItems?.forEach(item => {
//             item.addEventListener('keydown', function () {
//                 handelSubMenu(event, item);
//             });
//         });
//     });
// };
